import { http } from "services/http";

import type {
  ConversionExecuteRequest,
  ConversionExecuteResponse,
  ConversionPlan,
  ConversionPlanAddRequest,
  ConversionPlanAddResponse,
  ConversionPlanGetRequest,
  ConversionPlanUpdateRequest,
  ConversionUserRequest,
  ConversionUserResponse,
} from "models/conversion.model";

// Conversion plans (settings) and converting a single user's balances (user edit page).
export const conversionApi = {
  getConversionOpt: (data: ConversionUserRequest) =>
    http.quiet().post<ConversionUserResponse>("/api/conversion/user", { ...data }),
  convert: (data: ConversionExecuteRequest) =>
    http.quiet().post<ConversionExecuteResponse>("/api/conversion/execute", { ...data }),
  getPlans: () => http.quiet().get<ConversionPlan[]>("/api/conversion"),
  getPlan: (data: ConversionPlanGetRequest) =>
    http.quiet().post<ConversionPlan>("/api/conversion/get", { ...data }),
  addPlan: (data: ConversionPlanAddRequest) =>
    http.quiet().post<ConversionPlanAddResponse>("/api/conversion/add", { ...data }),
  editPlan: (data: ConversionPlanUpdateRequest) =>
    http.quiet().post("/api/conversion/update", { ...data }),
};
